// extracted by mini-css-extract-plugin
module.exports = {"sider":"navbar_sider__315Cm","title":"navbar_title__2XXEw"};